export default __webpack_public_path__ + "static/media/drop-box.37387f18.png";